import { Button, Grid2, TextField } from "@mui/material";
import { teal } from "@mui/material/colors";
import { Dayjs } from "dayjs";
import { useFormik } from "formik";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import React from "react";
interface CouponCode {
  couponCode: string;
  discountPercentage: number;
  start: Dayjs | null;
  end: Dayjs | null;
  minimumOrder: number;
}
export const AddNewCoupon = () => {
  const formik = useFormik<CouponCode>({
    initialValues: {
      couponCode: "",
      discountPercentage: 0,
      start: null,
      end: null,
      minimumOrder: 0,
    },
    onSubmit: (values) => {
     
      const formatedValues = {
        ...values,
        start: values.start?.toISOString(),
        end: values.end?.toISOString(),
      };
     
    },
  });
  return (
    <div className="pt-5  flex flex-col justify-center items-center">

    <div className=" w-[50vw]">
      <h1 className="text-2xl font-bold text-primary pb-5 text-center"> Create New Coupon</h1>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div className="">
        <Grid2 container spacing={3}>
          <Grid2 size={{ xs: 12, md: 6 }}>
            <TextField
              fullWidth
              name="couponCode"
              label="Coupon Code"
              value={formik.values.couponCode}
              onChange={formik.handleChange}
              error={
                formik.touched.couponCode && Boolean(formik.errors.couponCode)
              }
              helperText={formik.touched.couponCode && formik.errors.couponCode}
            />
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 6 }}>
            <TextField
              fullWidth
              name="discountPercentage"
              label="Discount Percentage"
              value={formik.values.discountPercentage}
              onChange={formik.handleChange}
              error={
                formik.touched.discountPercentage &&
                Boolean(formik.errors.discountPercentage)
              }
              helperText={
                formik.touched.discountPercentage &&
                formik.errors.discountPercentage
              }
            />
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 6 }}>
            <DatePicker
              sx={{ width: "100%" }}
              label="Validity Start Date"
              name="validityStartDate"
              onChange={formik.handleChange}
              value={formik.values.start}
            />
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 6 }}>
            <DatePicker
              sx={{ width: "100%" }}
              label="Validity End Date"
              name="validityEndDate"
              onChange={formik.handleChange}
              value={formik.values.end}
            />
          </Grid2>
          <Grid2 size={{ xs: 12 }}>
            <TextField
              fullWidth
              name="minimumOrder"
              label="Minimum Order"
              value={formik.values.minimumOrder}
              onChange={formik.handleChange}
              error={
                formik.touched.minimumOrder &&
                Boolean(formik.errors.minimumOrder)
              }
              helperText={
                formik.touched.minimumOrder && formik.errors.minimumOrder
              }
            />
          </Grid2>
          <Grid2 size={{ xs: 12 }}>
            <Button
              size="medium"
              fullWidth
              sx={{ backgroundColor: teal[500] }}
              variant="contained"
            >
              Create Coupon
            </Button>
          </Grid2>
        </Grid2>
      </div>
    </LocalizationProvider>
    </div>
    </div>
  );
};
